module.exports = require("./lib/dom/dom.js");



//////////////////
// WEBPACK FOOTER
// ./node_modules/@spothero/utils/dom.js
// module id = 165
// module chunks = 0